import { render, staticRenderFns } from "./studyDetail.vue?vue&type=template&id=1bee0b92&scoped=true"
import script from "./studyDetail.vue?vue&type=script&lang=js"
export * from "./studyDetail.vue?vue&type=script&lang=js"
import style0 from "./studyDetail.vue?vue&type=style&index=0&id=1bee0b92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bee0b92",
  null
  
)

export default component.exports